var _path, _path2, _g, _g2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77734 39.5238V29.0476L16.1107 35.7143L4.77734 39.5238Z",
    fill: "#81593B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2227 39.5238V29.0476L19.8893 35.7143L31.2227 39.5238Z",
    fill: "#81593B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_862_10120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0009 0L34.0564 9.52381V28.5714L18.0009 38.0952L1.94531 28.5714V9.52381L18.0009 0Z",
    fill: "#81593B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_862_10120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0004 4.76196L30.2782 11.9048V26.1905L18.0004 33.3334L5.72266 26.1905V11.9048L18.0004 4.76196Z",
    fill: "url(#paint0_linear_862_10120)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5909 17.6117C23.2468 14.7323 21.0856 13.0764 18.2241 13.0764C14.9581 13.0764 12.4648 15.4019 12.4648 19.4806C12.4648 23.5472 14.9158 25.8849 18.2241 25.8849C21.3935 25.8849 23.3072 23.7603 23.5909 21.4652L20.9467 21.453C20.6992 22.7862 19.6609 23.5533 18.2663 23.5533C16.3888 23.5533 15.1151 22.147 15.1151 19.4806C15.1151 16.8873 16.3707 15.408 18.2844 15.408C19.7152 15.408 20.7475 16.242 20.9467 17.6117H23.5909Z",
    fill: "#6C462A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94531 28.5714V9.52381L18.0009 0V4.76191L5.72309 11.9048V26.1905L1.94531 28.5714Z",
    fill: "#9D7456"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_862_10120",
    x: 0.945312,
    y: 0,
    width: 34.1113,
    height: 41.0952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_862_10120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_862_10120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_862_10120",
    x: 5.72266,
    y: 4.76196,
    width: 24.5547,
    height: 29.5715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.366951 0 0 0 0 0.267785 0 0 0 0 0.176248 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_862_10120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_10120",
    x1: 3.38403,
    y1: 4.76196,
    x2: 34.4568,
    y2: 35.1806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#856239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C39865"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.2fcff60ed4d2d3174ec772ab976902b6.svg";
export { ForwardRef as ReactComponent };